import { ChevronDownIcon } from '@heroicons/react/24/outline';

// Phone summary of the chart filters; any chip opens the options sheet. An
// inactive market gets a plain status pill first (the Header's inactive badge
// recipe), which is not a control. The row wraps (two lines at worst) so no
// chip is ever clipped at 360px.
export default function ChartChips({ chips, onOpen, inactive = false }) {
  return (
    <div role="group" aria-label="Chart options" className="mt-2.5 flex flex-wrap gap-2">
      {inactive && (
        <span className="inline-flex flex-none items-center self-center rounded-full border border-gray-300 px-2.5 py-0.5 text-xs font-medium text-gray-700 dark:border-gray-600 dark:text-gray-300">
          Inactive
        </span>
      )}
      {/* Positional keys keep each button across label changes, so focus
          can return to the chip that opened the sheet after Apply. */}
      {chips.map((c, i) => (
        <button
          key={i}
          type="button"
          onClick={onOpen}
          aria-haspopup="dialog"
          className="inline-flex h-10 flex-none items-center gap-1.5 rounded-full border border-gray-200/70 bg-surface px-3 text-[13px] font-medium text-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 dark:border-gray-600/70 dark:bg-gray-870 dark:text-gray-100"
        >
          {c}
          <ChevronDownIcon className="h-3 w-3 text-gray-400" aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
